import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { observable } from 'mobx-angular';
import { filter, map, mergeMap } from 'rxjs/operators';
import { GlobalsService } from './globals.service';

export enum HeaderBar {
  Default,
  ShowSaveButton,
}

@Injectable({
  providedIn: 'root',
})
export class HeaderBarService {
  @observable headerBarState = HeaderBar.Default;

  constructor(
    private globals: GlobalsService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {
    router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .pipe(map(() => activatedRoute))
      .pipe(
        map((route) => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
      )
      .pipe(filter((route) => route.outlet === 'primary'))
      .pipe(mergeMap((route) => route.data))
      .subscribe((data) => {
        this.headerBarState =
          data.headerBarState !== null
            ? data.headerBarState
            : HeaderBar.Default;
      });
  }
}
